import React from "react";
import AppLoadingOverlay from "../../../../components/AppLoadingOverlay";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const niceToKnowItems = [
  "AppWorkspace loading zeigt Seitentitel und Untertitel weiterhin an.",
  "Toolbar, Suche, Navigation und Inhalte werden erst nach dem Laden angezeigt.",
  'scope="contained" legt das Overlay nur über einen einzelnen Bereich.',
  "Label NICHT überschreiben, immer Default = Laden... anzeigen lassen.",

];

function LoadingOverlayPreview() {
  return (
    <DocsPreviewPanel title='scope="contained"'>
      <div className="ds-docs-preview-surface ds-docs-loading-preview-stage">
        <div className="ds-docs-loading-preview-stage__content">
          <div className="ds-docs-loading-preview-stage__header">
            <div className="ds-docs-loading-preview-stage__title">Formularbereich</div>
            <div className="ds-docs-loading-preview-stage__meta">Speichern gesperrt</div>
          </div>
          <div className="ds-docs-loading-preview-stage__rows">
            <div className="ds-docs-loading-preview-stage__row" />
            <div className="ds-docs-loading-preview-stage__row ds-docs-loading-preview-stage__row--short" />
            <div className="ds-docs-loading-preview-stage__row" />
          </div>
        </div>

        <AppLoadingOverlay open scope="contained"/>
      </div>
    </DocsPreviewPanel>
  );
}

export default function LoadingOverlaysDocs() {
  return (
    <DocsSectionCard title="Loading Overlays">
      <div className="ds-docs-spotlight-grid">
        <div className="ds-docs-loading-preview-stack">
          <LoadingOverlayPreview />
        </div>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
